// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-cta[data-v-3b03119e]{display:flex;flex-direction:column;align-items:center}.article-cta .article-cta__title[data-v-3b03119e]{margin-top:0;margin-bottom:1.25rem}.article-cta .article-cta__link[data-v-3b03119e]{padding-left:3rem;padding-right:3rem}@media (max-width:959px){.article-cta .article-cta__link[data-v-3b03119e]:focus{text-decoration:none}}@media (min-width:960px){.article-cta .article-cta__link[data-v-3b03119e]:hover{text-decoration:none}}", ""]);
// Exports
module.exports = exports;
